var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useMemo, useState } from "react";
import userIcon from "assets/img/userIcon.png";
import PopoverMenu from "./PopoverMenu";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import Tooltip from "./Tooltip";
var HeaderAccount = function (_a) {
    var loggedInRole = _a.loggedInRole, groupID = _a.groupID;
    var navigate = useNavigate();
    var _b = useContext(AuthContext), userData = _b.userData, logout = _b.logout, globalConfig = _b.globalConfig;
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var isBillingDisabled = useMemo(function () {
        var _a;
        return ((_a = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.find(function (e) { return e.key === "isBillingDisabled"; })) === null || _a === void 0 ? void 0 : _a.value) ===
            "true" || false;
    }, [globalConfig]);
    var options = useMemo(function () {
        return __spreadArray(__spreadArray(__spreadArray([
            {
                value: "_My_Profile",
                label: t("_My_Profile"),
                onClick: function () {
                    navigate("/app/header/change-profile");
                },
            }
        ], (loggedInRole !== "PA" && !isBillingDisabled
            ? [
                {
                    value: "_Billing",
                    label: t("_Billing"),
                    onClick: function () {
                        navigate("/app/header/billing");
                    },
                },
            ]
            : []), true), (loggedInRole == "EA" || loggedInRole == "EU"
            ? []
            : [
                {
                    value: "_Settings",
                    label: t("_Settings"),
                    onClick: function () {
                        navigate("/app/header/settings/".concat(groupID));
                    },
                },
            ]), true), [
            {
                value: "_Log_out",
                label: t("_Log_out"),
                onClick: function () {
                    logout();
                },
            },
        ], false);
    }, [loggedInRole, groupID, isBillingDisabled]);
    var name = userData.name;
    return (_jsx(PopoverMenu, { options: options, offsetX: 22, contentMinWidth: "150px", className: "px-6 py-3", open: open, setOpen: setOpen, children: _jsxs("div", { className: "flex cursor-pointer relative", children: [_jsx("img", { src: (userData === null || userData === void 0 ? void 0 : userData.profileImg) || userIcon, className: "rounded-full h-9  w-10 object-cover ltr:mr-[8px] rtl:ml-[8px] select-none", alt: "user-icon" }), _jsx("h1", { className: "font-nunito my-auto ltr:mr-[31px] rtl:ml-[31px] hidden sm:inline-block font-bold", children: (name === null || name === void 0 ? void 0 : name.length) > 12 ? (_jsx(Tooltip, { content: name, disabled: open, children: _jsx("span", { children: name.substring(0, 12) + "..." }) })) : (name) })] }) }));
};
export default HeaderAccount;
